import React from "react";
import { useSelector } from "react-redux";
import MainTemplate from "../../mainTemplate";
import ProviderProfile from "./providerProfile";
import ClientsProvider from "../clientsProvider";
import ProviderUsers from "../users/providerUsers/";
import Tabs from "../../../public/tableProvider/tabs";
import ProviderServices from "../services/providerServices";
import { getOneProvider } from "../../../../Redux/reducer/providers";
import ProviderAccount from "../accounts/providerAccount";
import { useTranslation } from "react-i18next";

const TabsProvider = () => {
  const provider = useSelector(getOneProvider);

  const headers = useTranslation().t(["providers.tabs"], {
    returnObjects: true,
  });

  const tabs = {
    0: <ProviderProfile />,
    1: <ProviderServices />,
    2: <ProviderAccount provider={provider.provider} />,
    3: <ProviderUsers />,
    4: (
      <ClientsProvider
        providerId={provider.provider?.id}
        countryCode={provider.provider?.country.code}
      />
    ),
  };

  return (
    <MainTemplate>
      <div className="client-profile">
        <h2 className="client">
          {provider.companyName !== undefined && (
            <>
              <img
                src={`data:image/png;base64,${provider?.countryCompany?.flag}`}
              />
              {provider.companyName} / {provider.businessId}
            </>
          )}
        </h2>
        <div className="header-tabs">
          <Tabs>
            {Object.keys(tabs).map((key) => (
              <div label={headers[key]} key={key}>
                {tabs[key]}
              </div>
            ))}
          </Tabs>
        </div>
      </div>
    </MainTemplate>
  );
};

export default TabsProvider;
